WW.becontacted = function ($) {
    const modalDialog = $('#modal-dialog');

    modalDialog.on('click', '.js-be-contacted-submit', function() {
        var phoneNumber= $('.js-validate-phone').val();
        var phonePattern = /^[0-9\-\+\(\)\s]+$/;
        if ( phonePattern.test( phoneNumber ) ) {
            $('.js-validate-phone-error').hide();
            return true;
        }
        else {
            $('.js-validate-phone-error').show();
            return false;
        }
    });

    return this;
};

